<script>
    import {createEventDispatcher} from 'svelte/internal';
    import {clickOutside} from '../js/clickOutside.js';
    import {DMY, setFocusTo, YMD} from "../js/utils";
    import Icon from "../components/icons/Icon.svelte";
    import CalendarControl from "./CalendarControl.svelte";

    export let value = null;
    export let startDate = '';
    export let id = 'datepicker-' + Math.random();
    // export let readonly = false;
    export let required = false;
    export let iconOnly = false;
    export let hideToday = false;
    export let hideClear = false;
    export let placeholder = null;
    export let topInfo = null;
    export let bottomInfo = null;
    export let openRight = false;

    let inputDate = null;
    let showCalendar = false;

    const dispatch = createEventDispatcher();

    const DMYFromYMD = (value) => {
        if (!value) return '';

        const [y, m, d] = String(value).split('-');

        if (!y || !m || !d) return '';

        return `${d}-${m}-${y}`;
    };

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeCalendar();
        }
    }

    const toggleCalendar = () => {
        if (!showCalendar) {
            openCalendar();
        } else {
            closeCalendar();
        }
    }

    const openCalendar = () => {
        if (!showCalendar) {
            showCalendar = true;
            document.addEventListener('keydown', handleEscapeKey);
        }
    }

    const closeCalendar = () => {
        if (showCalendar) {
            showCalendar = false;
            document.removeEventListener('keydown', handleEscapeKey);
        }
    }

    const onCalendarDateChange = ({detail}) => {
        value = detail;
        closeCalendar();
        dispatch('change', value);
        setFocusTo(id);
    }

    const onInputClick = () => {
        openCalendar();
    }

    // const onInputChange = (event) => {
    //     const raw = event.target.value?.trim();
    //
    //     if (raw) {
    //         const newDate = YMD(raw); // πρέπει να δίνει YYYY-MM-DD
    //
    //         if (/^\d{4}-\d{2}-\d{2}$/.test(newDate)) {
    //             value = newDate;
    //             dispatch('change', value);
    //         } else {
    //             console.log("wrong date");
    //         }
    //     } else {
    //         value = null;
    //         dispatch('change', value);
    //     }
    // };

    $:{
        inputDate = DMYFromYMD(value);
    }
</script>

<div class="date-control" class:form-item={ topInfo || bottomInfo }>
    {#if iconOnly}
        <div class="date-icon" on:click={toggleCalendar}>
            <Icon name="calendar" size="18"/>
        </div>
    {:else}
        <input type="text" class="form-control" {id} value={inputDate} readonly {required}
               on:click={onInputClick} on:keydown|preventDefault {placeholder}>
        {#if !inputDate}
            <div class="input-icon" on:click={openCalendar}>
                <Icon name="calendar"/>
            </div>
        {/if}
    {/if}
    {#if topInfo}
        <div class="form-item-info top">
            { topInfo}
        </div>
    {/if}
    {#if bottomInfo}
        <div class="form-item-info">
            { bottomInfo}
        </div>
    {/if}
    {#if showCalendar}
        <div class="calendar" class:open-right={openRight} class:centered={ iconOnly } use:clickOutside
             on:click_outside={closeCalendar}>
            <CalendarControl date={value} {hideToday} {hideClear} {startDate} on:change={onCalendarDateChange}/>
        </div>
    {/if}
</div>

<style>
    .date-control {
        position: relative;
    }

    /*.date-control .form-control {*/
    /*    min-width: 130px;*/
    /*}*/

    .date-icon {
        line-height: 1;
        padding: 5px 10px;
        cursor: pointer;
    }

    .input-icon {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        line-height: 1;
        padding: 5px 10px;
        cursor: pointer;
    }

    .calendar {
        position: absolute;
        box-shadow: var(--dropdown-box-shadow);
        z-index: 5000;
    }

    .calendar.centered {
        left: 50%;
        transform: translatex(-50%);
    }

    .calendar.open-right {
        left: unset;
        right: 0;
    }
</style>